<div class="side-menu">
	<div class="row">
		<div
			class="col-xs-12 col-sm-6 col-md-12 user-menu"
			*ngIf="user?.isAuthorized({ workflows: [workflowToken.ACCOUNT_USER_SELF_ADMINISTRATION, workflowToken.ACCOUNT_USER_RESET_PASSWORD] })"
		>
			<div class="content">
				<div class="header user">
					{{ 'translationService.title.myAccount' | translate }}
				</div>
				<ul>
					<li *ngIf="user?.isAuthorized({ workflows: workflowToken.ACCOUNT_USER_SELF_ADMINISTRATION })">
						<a [routerLink]="['/', 'user', 'edit']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.userDetails' | translate }}
						</a>
					</li>
					<li *ngIf="user?.isAuthorized({ workflows: workflowToken.ACCOUNT_USER_RESET_PASSWORD })">
						<a [routerLink]="['/', 'user', 'changepassword']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.changePassword' | translate }}
						</a>
					</li>
				</ul>
			</div>
		</div>
		<div
			class="col-xs-12 col-sm-6 col-md-12 customer-menu"
			*ngIf="user?.isAuthorized({ workflows: [workflowToken.ACCOUNT_CUSTOMER_EDIT] })"
		>
			<div class="content">
				<div class="header customer">
					{{ 'translationService.title.myCompany' | translate }}
				</div>
				<ul>
					<li *ngIf="user?.isAuthorized({ workflows: workflowToken.ACCOUNT_CUSTOMER_EDIT })">
						<a [routerLink]="['/', 'customer', 'editcustomer']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.companyInfo' | translate }}
						</a>
					</li>
					<li
						*ngIf="
							user?.isAuthorized({
								workflows: [workflowToken.ACCOUNT_CUSTOMER_EDIT_BILLING_ADDRESS, workflowToken.ACCOUNT_CUSTOMER_EDIT_SHIPPING_ADDRESS]
							})
						"
					>
						<a [routerLink]="['/', 'customer', 'editaddress']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.addresses' | translate }}
						</a>
					</li>
					<li
						*ngIf="
							user?.isAuthorized({
								roles: [userRole.LAB_USER],
								workflows: [workflowToken.ACCOUNT_LAB_EDIT_OFFERINGS_AND_SERVICES, workflowToken.ACCOUNT_LAB_EDIT_LAB_PROFILE]
							})
						"
					>
						<a [routerLink]="['/', 'customer', 'editlabprofile']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.laboratoryProfile' | translate }}
						</a>
					</li>
					<li
						*ngIf="
							user?.isAuthorized({ roles: [userRole.LAB_USER], workflows: workflowToken.ACCOUNT_LAB_EDIT_ADDITIONAL_ORDER_INFORMATION })
						"
					>
						<a [routerLink]="['/', 'customer', 'editadditionalorderinformation']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.additionalOrderOptions' | translate }}
						</a>
					</li>
					<li *ngIf="user?.isAuthorized({ workflows: workflowToken.ACCOUNT_CUSTOMER_EDIT })">
						<a [routerLink]="['/', 'customer', 'disablecustomer']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.deactivateAccount' | translate }}
						</a>
					</li>
				</ul>
			</div>
		</div>
		<div
			class="col-xs-12 col-sm-6 col-md-12 partner-menu"
			*ngIf="
				user?.isAuthorized({
					workflows: [
						workflowToken.ACCOUNT_LINKED_PORTALS_EDIT,
						workflowToken.ACCOUNT_CONTRACTOR_EDIT_CONNECTED_PURCHASERS,
						workflowToken.ACCOUNT_LAB_EDIT_CONNECT_DIRECT,
						workflowToken.ACCOUNT_DENTIST_EDIT_FAVORITE_LABS
					]
				})
			"
		>
			<div class="content" *ngIf="!isDisconnectedUser()">
				<div class="header partner">
					{{ 'translationService.title.partner' | translate }}
				</div>
				<ul>
					<li
						*ngIf="
							user?.isAuthorized({ roles: [userRole.LAB_USER], workflows: [workflowToken.ACCOUNT_CONTRACTOR_EDIT_CONNECTED_PURCHASERS] })
						"
					>
						<a [routerLink]="['/', 'partner', 'transmitterlist']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.mySender' | translate }}
						</a>
					</li>
					<li *ngIf="!isDisconnectedUser() && user?.isAuthorized({ workflows: workflowToken.ACCOUNT_DENTIST_EDIT_FAVORITE_LABS })">
						<a [routerLink]="['/', 'partner', 'editfavoritelabs']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.myRecipients' | translate }}
						</a>
					</li>
					<li *ngIf="user?.isAuthorized({ roles: [userRole.LAB_USER], workflows: [workflowToken.ACCOUNT_LAB_EDIT_CONNECT_DIRECT] })">
						<a [routerLink]="['/', 'partner', 'editlablock']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.connectDirect' | translate }}
						</a>
					</li>
					<li *ngIf="!isDisconnectedUser() && user?.isAuthorized({ workflows: [workflowToken.ACCOUNT_LINKED_PORTALS_EDIT] })">
						<a [routerLink]="['/', 'partner', 'editexternalpartnercredentials']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.linkedPortals' | translate }}
						</a>
					</li>
				</ul>
			</div>
		</div>
		<div
			class="col-xs-12 col-sm-6 col-md-12 orderlist-menu"
			*ngIf="user?.isAuthorized({ workflows: [workflowToken.LAB_ORDER_LIST_SHOW, workflowToken.DENTIST_ORDER_LIST_SHOW] })"
		>
			<div class="content">
				<div class="header orderlist">
					{{ 'translationService.title.orderList' | translate }}
				</div>
				<ul>
					<li *ngIf="user?.isAuthorized({ roles: [userRole.LAB_USER], workflows: [workflowToken.LAB_ORDER_LIST_SHOW] })">
						<a [routerLink]="['/', 'orderlist', 'received']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.receivedOrders' | translate }}
						</a>
					</li>
					<li *ngIf="user?.isAuthorized({ workflows: [workflowToken.DENTIST_ORDER_LIST_SHOW] })">
						<a [routerLink]="['/', 'orderlist', 'sent']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.sentOrders' | translate }}
						</a>
					</li>
				</ul>
			</div>
		</div>
		<div
			class="col-xs-12 col-sm-6 col-md-12 users-menu"
			*ngIf="user?.isAuthorized({ workflows: [workflowToken.ACCOUNT_DISPLAY_CUSTOMER_USER_MANAGEMENT] })"
		>
			<div class="content">
				<div class="header users">
					{{ 'translationService.title.userManagement' | translate }}
				</div>
				<ul>
					<li>
						<a [routerLink]="['/', 'users', 'list']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.userList' | translate }}
						</a>
					</li>
				</ul>
			</div>
		</div>
		<div
			class="col-xs-12 col-sm-6 col-md-12 cib-menu"
			*ngIf="user?.isAuthorized({ workflows: [workflowToken.CONNECTINBOX_WORKSTATIONS_SHOW] })"
		>
			<div class="content">
				<div class="header cib">
					{{ 'translationService.title.connectInBox' | translate }}
				</div>
				<ul>
					<li>
						<a [routerLink]="['/', 'connectinbox', 'workstations']" routerLinkActive="active" (click)="closeMenu()">
							{{ 'translationService.button.connectInBoxWorkstations' | translate }}
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>
